import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from './baseIvrNode';
import { IsNotEmpty, IsOptional, IsString, Length } from 'class-validator';

export default class SmsNode extends BaseIvrNode {
  @IsString()
  @Length(1, 1600)
  @IsNotEmpty()
  body: string;

  @IsString()
  @IsOptional()
  number?: string;

  @IsString()
  @IsOptional()
  nextId?: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}
